"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToHTML = void 0;
const escapeHtml = require("escape-html");
// this converts WELL FORMATTED text that we generate ourselves to html
// do not use this to convert user input to html
function convertToHTML(plainText) {
    // Split the text into lines
    const lines = plainText.split('\n');
    let html = '';
    const listStack = [];
    for (let line of lines) {
        const trimmedLine = line.trim();
        // Determine the nesting level based on the number of leading spaces or tabs
        const indentationMatch = line.match(/^(\s*)/);
        const level = indentationMatch ? Math.floor(indentationMatch[1].length / 2) : 0;
        // Process list items
        if (trimmedLine.startsWith('- ') || trimmedLine.startsWith('* ')) {
            // Open a top-level list if we encounter the first list item and no list is open
            if (listStack.length === 0) {
                html += '<ul>';
                listStack.push('ul');
            }
            // Close lists if the current level is less than the previous level
            while (listStack.length > level + 1) {
                html += `</${listStack.pop()}>`;
            }
            // Open new lists if the current level is greater than the previous level
            while (listStack.length < level + 1) {
                html += '<ul>';
                listStack.push('ul');
            }
            // Remove the list item marker, escape HTML special characters, and wrap the item in li tags
            line = escapeHtml(trimmedLine.substring(2).trim());
            html += `<li>${line.replace(/\*+(.*?)\*+/g, '<strong>$1</strong>')}</li>`;
        }
        else if (trimmedLine === '') {
            let inList = false;
            // Close all open lists
            while (listStack.length > 0) {
                html += `</${listStack.pop()}>`;
                inList = true;
            }
            if (!inList) {
                // Process line breaks
                html += '<div><br></div>';
            }
        }
        else {
            // Process normal lines
            // Close all open lists
            while (listStack.length > 0) {
                html += `</${listStack.pop()}>`;
            }
            // Escape HTML special characters and wrap the line in div tags
            line = escapeHtml(trimmedLine);
            // Replace asterisks with <strong></strong> tags
            line = line.replace(/\*+(.*?)\*+/g, '<strong>$1</strong>');
            html += `<div>${line}</div>`;
        }
    }
    // Close any remaining open lists at the end of the text
    while (listStack.length > 0) {
        html += `</${listStack.pop()}>`;
    }
    return html;
}
exports.convertToHTML = convertToHTML;
//# sourceMappingURL=text-to-html.js.map